import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export const appGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
  next()
}
